import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    obtemTextoArray,
} from '../../../business-components/Array/Array'

import {
    dia,
} from '../../../business-components/Date/Date'

//import {
//    zerosEsquerda
//} from '../../../business-components/String/String'

import {
    trataValorTexto,
    trataData,
} from '../cliente-form/ClienteServiceImportacao'

import {
    espaco,
    fimLinha,
    identificaTipoCoberturaSeguroVida,
    indexAtualJsonRegistros,
    obtemDadoPDF,
    obtemDadoXLSX,
    obtemDadoPDFAvulso,
    converterCnpjEmpresa,
    jsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosAtualizaErros,
    incluiCoberturas,
} from './IntegracaoClienteArquivoService'



export const importaApoliceOmint = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

    PDFTxt = PDFTxt.replaceAll(fimLinha + 'NÚMERO DE APÓLICE' + espaco, fimLinha + 'NÚMERO DA APÓLICE' + espaco)
    //console.log(PDFTxt)



    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'NÚMERO DA APÓLICE' + espaco, espaco,
        HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)
    
    obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'NÚMERO DA PROPOSTA' + espaco, espaco,
        HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)
    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'DATA DE EMISSÃO' + espaco, espaco, 
        HARDCODE.importacaoDataEmissao, false, null, erros, nomeArquivo)
    
    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].dataEmissao) {

        obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Início' + espaco, espaco, 
            HARDCODE.importacaoDataEmissao, true, null, erros, nomeArquivo)
    }
    


    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'NOME COMPLETO DATA DE NASCIMENTO CPF' + fimLinha, fimLinha,
        HARDCODE.importacaoLinhaDados, false, null, erros, nomeArquivo)

    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'NOME CIVIL DATA DE NASCIMENTO CPF' + fimLinha, fimLinha,
            HARDCODE.importacaoLinhaDados, false, null, erros, nomeArquivo)
    }

    let linhaDados = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(espaco)
    let tamLinhaDados = linhaDados.length

    obtemDadoPDFAvulso (jsonRegistros, obtemTextoArray(linhaDados, 0, tamLinhaDados - 3),
        HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDFAvulso (jsonRegistros, linhaDados[tamLinhaDados - 2],
        HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDFAvulso (jsonRegistros, linhaDados[tamLinhaDados - 1],
        HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)



    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'ENDEREÇO N° COMPLEMENTO' + fimLinha, fimLinha,
        HARDCODE.importacaoEnderecoSeguradoCliente, false, null, erros, nomeArquivo)

    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].enderecoSeguradoCliente) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'N° COMPLEMENTOENDEREÇO' + fimLinha, fimLinha,
            HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)
    }



    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'BAIRRO CIDADE UF CEP' + fimLinha, fimLinha,
        HARDCODE.importacaoLinhaDados, false, null, erros, nomeArquivo)

    linhaDados = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(espaco)
    tamLinhaDados = linhaDados.length

    obtemDadoPDFAvulso (jsonRegistros, linhaDados[tamLinhaDados - 1],
        HARDCODE.importacaoCepSeguradoCliente, false/*true*/, null, erros, nomeArquivo)

    //obtemDadoPDFAvulso (jsonRegistros, linhaDados[tamLinhaDados - 2],
    //    HARDCODE.importacaoUfSeguradoCliente, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + '02 Endereço Residencial' + fimLinha + 'Cidade' + fimLinha, fimLinha,
    //    HARDCODE.importacaoCidadeSeguradoCliente, true, null, erros, nomeArquivo)
        
    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Bairro' + fimLinha, fimLinha,
    //    HARDCODE.importacaoBairroSeguradoCliente, true, null, erros, nomeArquivo)



    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Telefone' + fimLinha, fimLinha,
    //    HARDCODE.importacaoCelularSeguradoCliente, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Email' + fimLinha, fimLinha,
    //    HARDCODE.importacaoEmailSeguradoCliente, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Sexo' + fimLinha, fimLinha,
    //    HARDCODE.importacaoSexoSeguradoCliente, true, null, erros, nomeArquivo)
    
    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Profissão' + fimLinha, fimLinha, 
    //    HARDCODE.importacaoProfissaoSegurado, false, null, erros, nomeArquivo)

   

    jsonRegistros.jsonRegistros[indexJsonRegistros].statusApolice = HARDCODE.idStatusApoliceAtiva
    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Status da Apólice:' + espaco, fimLinha,
    //    HARDCODE.importacaoStatusApolice, true, linhaIntegracao.statusApolice, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha +
        'COBERTURAS BÁSICAS CAPITALSEGURADO INÍCIO DE VIGÊNCIA FIM DE VIGÊNCIA PRÊMIO LÍQUIDO' + fimLinha,
            fimLinha + 'PRÊMIO LÍQUIDO' + espaco, HARDCODE.importacaoCoberturas, false, null, erros, nomeArquivo)

    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha +
            'COBERTURAS CAPITAL SEGURADO INÍCIO DE VIGÊNCIA FIM DE VIGÊNCIA PRÊMIO LÍQUIDO' + fimLinha,
                fimLinha + 'PRÊMIO LÍQUIDO' + espaco, HARDCODE.importacaoCoberturas, true, null, erros, nomeArquivo)
    }
    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha +
        'PERIODICIDADE DO PAGAMENTO FORMA DE PAGAMENTO PRÊMIO ANUAL IOF PRÊMIO ANUAL TOTAL DIA DE VENCIMENTO' + fimLinha, espaco,
            HARDCODE.importacaoTipoPeriodicidadePagtoPremio, false, null, erros, nomeArquivo)

    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].tipoPeriodicidadePagtoPremio) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha +
            'Periodicidade de pagamento Forma de Pagamento Prêmio total da vigência IOF Prêmio total da vigência com IOF Dia de Vencimento' + fimLinha, espaco,
                HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)

        if (jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.indexOf('R$ ') === -1) {

            jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas =
                jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.replaceAll('R$', 'R$' + espaco)
        }
    }



    jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas =
        jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.replaceAll(
            'INVALIDEZ PERMANENTE' + espaco, espaco + 'INVALIDEZ PERMANENTE' + espaco)

    jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas =
        jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.replaceAll(
            'INVALIDEZ POR ACIDENTE' + espaco, espaco + 'INVALIDEZ POR ACIDENTE' + espaco)

    jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas =
        jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.replaceAll(
            'IPA MAJORADA', espaco + 'IPA MAJORADA')

    jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas =
        jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.replaceAll(
            'MORTE – COBERTURA TEMPORÁRIA', espaco + 'MORTE – COBERTURA TEMPORÁRIA')

    jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas =
        jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.replaceAll(
            'DOENÇAS GRAVES', espaco + 'DOENÇAS GRAVES')

    jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas =
        jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.replaceAll(
            'DIÁRIA DE INTERNAÇÃO HOSPITALAR', espaco + 'DIÁRIA DE INTERNAÇÃO HOSPITALAR')

    jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas =
        jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.replaceAll(
            'MORTE ACIDENTAL', espaco + 'MORTE ACIDENTAL')
    
    jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas =
        jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.replaceAll(
            'FUNERAL FAMILIAR', espaco + 'FUNERAL FAMILIAR')

    jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas =
        jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.replaceAll(
            'FUNERAL INDIVIDUAL', espaco + 'FUNERAL INDIVIDUAL')

    jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas =
        jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.replaceAll(
            'PROTEÇÃO CIRÚRGICA', espaco + 'PROTEÇÃO CIRÚRGICA')

    jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas =
        jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.replaceAll(
            'QUEBRA DE OSSOS', espaco + 'QUEBRA DE OSSOS')
    

    const linhasCobertura = []
    let indexLinhasCobertura = 0
    //console.log(jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas)

    const linhasCoberturaAux = jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.split(fimLinha)
    let indexLinhasPosicaoAux = 0

    const coberturas = []

    let dadosCobertura

    let numeroCobertura
    let codigoCobertura
    let descricaoCobertura
    let tipoCoberturaSeguroVida
    let valorCS
    let valorPremioLiquido
    let valorIof
    let valorPremio
    let classeAjusteRisco
    let valorPremioExtra
    let duracaoPremioExtra
    let dataTerminoCobertura
    let valorRendaMensal

    while (indexLinhasPosicaoAux < linhasCoberturaAux.length) {

        if (linhasCoberturaAux[indexLinhasPosicaoAux].indexOf('R$') !== -1) {

            linhasCobertura.push(linhasCoberturaAux[indexLinhasPosicaoAux])
        }

        indexLinhasPosicaoAux += 1
    }
//console.log(linhasCobertura)

    while (indexLinhasCobertura < linhasCobertura.length) {

        dadosCobertura = linhasCobertura[indexLinhasCobertura].split(espaco)
//console.log(dadosCobertura)

        let tamDadosCobertura = dadosCobertura.length

        if (linhasCobertura[indexLinhasCobertura].indexOf('*   M') === -1) {

            if (dadosCobertura[0] === 'R$') {

                descricaoCobertura = obtemTextoArray(dadosCobertura, 6, tamDadosCobertura - 1)

                valorCS = trataValorTexto(dadosCobertura[1])
                valorPremio = trataValorTexto(dadosCobertura[5])
                valorIof = 0
                valorPremioLiquido = valorPremio

                dataTerminoCobertura = trataData(dadosCobertura[3])

            } else {

                descricaoCobertura = obtemTextoArray(dadosCobertura, 0, tamDadosCobertura - 7)

                valorCS = trataValorTexto(dadosCobertura[tamDadosCobertura - 5])
                valorPremio = trataValorTexto(dadosCobertura[tamDadosCobertura - 1])

                dataTerminoCobertura = trataData(dadosCobertura[tamDadosCobertura - 3])
            }

            tipoCoberturaSeguroVida = identificaTipoCoberturaSeguroVida(descricaoCobertura, linhaIntegracao,
                jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

            incluiCoberturas(coberturas, numeroCobertura, codigoCobertura, descricaoCobertura, tipoCoberturaSeguroVida,
                HARDCODE.idStatusCoberturaAtivaPagandoPremio, valorCS, valorPremioLiquido, valorIof, valorPremio,
                    classeAjusteRisco, valorPremioExtra, duracaoPremioExtra, dataTerminoCobertura, valorRendaMensal)
        }
            
        indexLinhasCobertura++
    }

    jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas = coberturas


    
    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)



    return jsonRegistros.jsonRegistros
}



export const importaListaCobrancasOmint = (XLSX, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    //const timeSeguradoraAux = timeSeguradora(idUsuarioLogado, equipeList, seguradora)

    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    while (linha < XLSX.length) {

        if (XLSX[linha][0] && XLSX[linha][7]/*valorParcela*/ > 0) {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

            //const usuarioClienteSelecionado = idAgenteTimeSeguradora(timeSeguradoraAux, XLSX[linha][?])

            //if (usuarioClienteSelecionado) {

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 0, HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)
                
                obtemDadoXLSX(XLSX, jsonRegistros, linha, 4, HARDCODE.importacaoTipoFormaPagtoPremio, true, null, erros, nomeArquivo)

                //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoBanco, false, null, erros, nomeArquivo)
                //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoAgencia, false, null, erros, nomeArquivo)
                //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoConta, false, null, erros, nomeArquivo)
                //obtemDadoXLSX(XLSX, jsonRegistros, linha, 38, HARDCODE.importacaoLinhaDados, false, null, erros, nomeArquivo)

                //if (jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados) {

                //    const conta = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(espaco)

                //    jsonRegistros.jsonRegistros[indexJsonRegistros].banco = zerosEsquerda(conta[conta.length - 6], 3)
                //    jsonRegistros.jsonRegistros[indexJsonRegistros].agencia = conta[conta.length - 3]
                //    jsonRegistros.jsonRegistros[indexJsonRegistros].conta = conta[conta.length - 1]
                //}

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 3, HARDCODE.importacaoNumeroParcela, true, null, erros, nomeArquivo)

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 5, HARDCODE.importacaoStatusParcela, true, null, erros, nomeArquivo)

                //obtemDadoXLSX(XLSX, jsonRegistros, linha, 16, HARDCODE.importacaoTipoBaixaParcela, true, null, erros, nomeArquivo)

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 6, HARDCODE.importacaoDataVencimento, true, null, erros, nomeArquivo)
                
                //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoDiaVencimento, true, null, erros, nomeArquivo)
                jsonRegistros.jsonRegistros[indexJsonRegistros].diaVencimento =
                    dia(jsonRegistros.jsonRegistros[indexJsonRegistros].dataVencimento)

                //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoDataCompetencia, true, null, erros, nomeArquivo)

                //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoDataInicioVigencia, true, null, erros, nomeArquivo)

                //obtemDadoXLSX(XLSX, jsonRegistros, linha, 20, HARDCODE.importacaoDataFimVigencia, true, null, erros, nomeArquivo)

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 8, HARDCODE.importacaoDataPagamento, false, null, erros, nomeArquivo)

                //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoDataApropriacao, false, null, erros, nomeArquivo)

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 7, HARDCODE.importacaoValorAPagar, true, null, erros, nomeArquivo)

                //////obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorPago, true, null, erros, nomeArquivo)

                //////obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoTipoPeriodicidadePagtoPremio,
                //////    true, null, erros, nomeArquivo)

                //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoNumeroCobertura,
                //    true, null, erros, nomeArquivo)
                //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoCodigoCobertura,
                //    true, null, erros, nomeArquivo)
                //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoDescricaoCobertura,
                //    true, null, erros, nomeArquivo)
                //obtemDadoXLSX(XLSX, jsonRegistros, linha, 15, HARDCODE.importacaoLinhaDados, true, null, erros, nomeArquivo)

                //if (jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados) {

                //    const descricaoCobertura = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(' - ')

                //    jsonRegistros.jsonRegistros[indexJsonRegistros].codigoCobertura =
                //        descricaoCobertura[descricaoCobertura.length - 1]

                //    jsonRegistros.jsonRegistros[indexJsonRegistros].descricaoCobertura =
                //        obtemTextoArray(descricaoCobertura, 0, descricaoCobertura.length - 2)
                //}

            //} else {
        
            //    erros.push(MESSAGE().agenteNaoEncontradoApolice
            //        .replace("$numeroApolice$", XLSX[linha][?])
            //            .replace("$codigoAgente$", XLSX[linha][?])
            //    )
            //}

            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
        }

        linha++
    }

    return jsonRegistros.jsonRegistros
}



export const importaListaComissoesOmint = (XLSX, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    while (linha < XLSX.length) {

        if (XLSX[linha][0] && XLSX[linha][8] === 'Pagamento de Comissão de Corretagem') {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            //const usuarioClienteSelecionado = idAgenteTimeSeguradora(timeSeguradoraAux, XLSX[linha][30])

            ////const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 1, HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 8, HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 4, HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].numeroProposta

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 3, HARDCODE.importacaoNumeroParcela, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 9, HARDCODE.importacaoNumeroParcelaFaturada, false, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 35, HARDCODE.importacaoTipoFormaPagtoPremio, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 1, HARDCODE.importacaoDataGeracaoComissao, true, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 9, HARDCODE.importacaoValorBaseCalculoComissao, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 20, HARDCODE.importacaoPercAngariacao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percAngariacao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percAngariacao * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 19, HARDCODE.importacaoValorAngariacao, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 10, HARDCODE.importacaoPercComissao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao * 100

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 11, HARDCODE.importacaoValorComissao, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 24, HARDCODE.importacaoPercEstorno, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 23, HARDCODE.importacaoValorEstorno, true, null, erros, nomeArquivo)
            //if (jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao < 0) {

            //    jsonRegistros.jsonRegistros[indexJsonRegistros].valorBaseCalculoComissao =
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].valorBaseCalculoComissao * -1

            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno =
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].valorEstorno =
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao * -1

            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao = 0
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao = 0
            //}

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoPercComissaoCoCorretagem, false, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorComissaoCoCorretagem, false, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 26, HARDCODE.importacaoPercIncentivo, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percIncentivo =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percIncentivo * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 25, HARDCODE.importacaoValorIncentivo, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 28, HARDCODE.importacaoPercBonificacao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percBonificacao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percBonificacao * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 27, HARDCODE.importacaoValorBonificacao, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 9, HARDCODE.importacaoCodigoCobertura, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 8, HARDCODE.importacaoDescricaoCobertura, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorComissaoTotal, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoNumeroCobertura, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoAgentesComissao, true, null, erros, nomeArquivo)

            //if (usuarioClienteSelecionado) {
               
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].usuarioClienteSelecionado = usuarioClienteSelecionado
                 
            //} else {
        
            //    erros.push(MESSAGE().agenteNaoEncontradoApolice
            //        .replace("$numeroApolice$", jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)
            //            .replace("$codigoAgente$", XLSX[linha][30])
            //    )
            //}

            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
        }

        linha++
    }
    

    return jsonRegistros.jsonRegistros
}



export const importaListaComissoesOmintSegundoLayout = (XLSX, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    while (linha < XLSX.length) {

        if (XLSX[linha][0] && XLSX[linha][8] === 'Pagamento de Comissão de Corretagem') {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            //const usuarioClienteSelecionado = idAgenteTimeSeguradora(timeSeguradoraAux, XLSX[linha][30])

            const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 1, HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 8, HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 4, HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].numeroProposta

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 3, HARDCODE.importacaoNumeroParcela, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 9, HARDCODE.importacaoNumeroParcelaFaturada, false, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 35, HARDCODE.importacaoTipoFormaPagtoPremio, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 1, HARDCODE.importacaoDataGeracaoComissao, true, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 9, HARDCODE.importacaoValorBaseCalculoComissao, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 20, HARDCODE.importacaoPercAngariacao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percAngariacao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percAngariacao * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 19, HARDCODE.importacaoValorAngariacao, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 10, HARDCODE.importacaoPercComissao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao * 100

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 11, HARDCODE.importacaoValorComissao, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 24, HARDCODE.importacaoPercEstorno, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 23, HARDCODE.importacaoValorEstorno, true, null, erros, nomeArquivo)
            //if (jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao < 0) {

            //    jsonRegistros.jsonRegistros[indexJsonRegistros].valorBaseCalculoComissao =
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].valorBaseCalculoComissao * -1

            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno =
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].valorEstorno =
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao * -1

            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao = 0
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao = 0
            //}

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoPercComissaoCoCorretagem, false, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorComissaoCoCorretagem, false, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 26, HARDCODE.importacaoPercIncentivo, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percIncentivo =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percIncentivo * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 25, HARDCODE.importacaoValorIncentivo, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 28, HARDCODE.importacaoPercBonificacao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percBonificacao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percBonificacao * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 27, HARDCODE.importacaoValorBonificacao, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 9, HARDCODE.importacaoCodigoCobertura, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 8, HARDCODE.importacaoDescricaoCobertura, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorComissaoTotal, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoNumeroCobertura, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoAgentesComissao, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 12, HARDCODE.importacaoCnpjEmpresa, true, null, erros, nomeArquivo)

            jsonRegistros.jsonRegistros[indexJsonRegistros].cnpjEmpresa =
                converterCnpjEmpresa(vars, jsonRegistros.jsonRegistros[indexJsonRegistros].cnpjEmpresa)

            //if (usuarioClienteSelecionado) {
               
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].usuarioClienteSelecionado = usuarioClienteSelecionado
                 
            //} else {
        
            //    erros.push(MESSAGE().agenteNaoEncontradoApolice
            //        .replace("$numeroApolice$", jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)
            //            .replace("$codigoAgente$", XLSX[linha][30])
            //    )
            //}

            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
        }

        linha++
    }
    

    return jsonRegistros.jsonRegistros
}